import gql from 'graphql-tag';

export default gql`
  mutation AddLipidProfileMeasurementMutation($request: LipidProfileTestInputType!) {
    diabetes {
      lipidTest(testData: $request) {
        __typename
        ... on BasicMutationSuccess {
          code
        }
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;
